export const lightTheme = {
    background: '#fff',
    text: '#0C1E28',
    buttonBg: '#6FCBD1',
    buttonText: '#fff'
};

export const darkTheme = {
    background: '#0C1E28',
    text: '#ffffff',
    buttonBg: '#fff',
    buttonText: '#6FCBD1'
};